<template>
  <div id="layout-basic">
    <header>
      <BasicHeader :current-user="currentUser"></BasicHeader>
    </header>
    <div :class="{ 'mt129': isHome }" style=" minHeight: calc(100vh - 195px)">
      <router-view :key="key"/>
    </div>
    <footer>
      <BasicFooter></BasicFooter>
    </footer>
    <a-back-top />
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { BasicHeader, BasicFooter } from './modules';
export default {
  name: 'BasicLayout',
  components: {
    BasicHeader,
    BasicFooter
  },
  data(){
	  return {
	  }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.info
    }),
    key() {
      return this.$route.path
    },
    isHome() {
      return this.$route.path == '/' ? false : true
    }
  },
  methods: {
	  
	 
  }
}
</script>

<style scoped lang="less">
#layout-basic {
  overflow: hidden;
  padding: 0;
  width: 100%;

  ::v-deep .ant-back-top-content {
    // background-color: #ffa500;
  }

  // header {
  //   position: relative;
  //   max-width: 100%;
  //   position: fixed;
  //   top: 0;
  //   right: 0;
  //   left: 0;
  //   z-index: 99;
  // }

  footer {
    // background: url(../assets/images/footer_bg.png) no-repeat center;
    min-width: 1200px;
  }

}
</style>